import { useField } from "formik";
import { useEffect } from "react";

/**
 * @description - Custom hook to delay some action based on value changed
 * @param {string} fieldName - Value that going to be change
 * @param {Function} callBack - Callback function to execute when the delay passed
 * @param {number} delay - Delay in milliseconds, default is 500ms
 */
const useDebounceField = <T,>(
  fieldName: string,
  callBack: (value: string) => void,
  delay: number = 500
) => {
  const [, meta] = useField(fieldName);
  const { value } = meta;

  useEffect(() => {
    const timeout = setTimeout(() => {
      callBack(value);
    }, delay);

    return () => clearTimeout(timeout);
  }, [value, delay]);
};

export default useDebounceField;
